export default __webpack_public_path__ + "static/media/footer-text.43ed6fd6.svg";